/**
 * Class Timeline service — READ-ONLY access to the per-class audit history at
 * `classes/{classId}/timeline/{eventId}`.
 *
 * Every event that ever happened to a class (created → reschedule requested →
 * accepted → rescheduled → reminder sent → completed …) is appended by the
 * Cloud Functions and never edited or deleted (rules-enforced). Event shape:
 *   { at, type, summary, actorRole, actorId, actorName, data }
 *
 * Event types: see TIMELINE_TYPE in functions/src/scheduling/timeline.js.
 */
import firestoreService, { orderBy } from './firestore.service';

export const classTimelineService = {
  /** Chronological realtime feed of one class's events. */
  subscribeByClass(classId, onData, onError) {
    return firestoreService.subscribeCollection(
      `classes/${classId}/timeline`,
      [orderBy('at', 'asc')],
      onData,
      onError
    );
  },

  listByClass(classId) {
    return firestoreService.getCollection(`classes/${classId}/timeline`, [orderBy('at', 'asc')]);
  },
};

export default classTimelineService;
